import React, { useEffect, useState } from 'react';
import { Check, X, AlertTriangle, Info } from 'lucide-react';
import { subscribe, dismiss, ToastItem } from '../lib/toast';

const palette: Record<string, { wrap: string; icon: string }> = {
  success: { wrap: 'bg-white border-green-200 text-green-800', icon: 'text-green-600' },
  error: { wrap: 'bg-white border-red-200 text-red-700', icon: 'text-red-500' },
  warning: { wrap: 'bg-white border-amber-200 text-amber-800', icon: 'text-amber-500' },
  info: { wrap: 'bg-white border-gray-200 text-gray-800', icon: 'text-gray-500' },
};

const Icon: React.FC<{ type: string; className: string }> = ({ type, className }) => {
  if (type === 'success') return <Check className={className} />;
  if (type === 'error') return <X className={className} />;
  if (type === 'warning') return <AlertTriangle className={className} />;
  return <Info className={className} />;
};

const Toaster: React.FC = () => {
  const [items, setItems] = useState<ToastItem[]>([]);

  useEffect(() => subscribe(setItems), []);

  if (items.length === 0) return null;

  return (
    <div className="fixed top-5 left-1/2 -translate-x-1/2 z-[9999] flex flex-col gap-2 items-center pointer-events-none">
      <style>{`
        @keyframes toast-in {
          from { opacity: 0; transform: translateY(-8px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .toast-item { animation: toast-in 160ms ease-out; }
      `}</style>
      {items.map((item) => {
        const p = palette[item.type] || palette.info;
        return (
          <div
            key={item.id}
            className={`toast-item pointer-events-auto flex items-center gap-2.5 px-4 py-2.5 rounded-xl border ${p.wrap} shadow-lg max-w-md`}
          >
            <span className={`${p.icon} flex-shrink-0`}>
              <Icon type={item.type} className="w-4 h-4" />
            </span>
            <span className="text-sm font-medium leading-snug break-words">{item.message}</span>
            <button
              onClick={() => dismiss(item.id)}
              className="ml-1 text-gray-400 hover:text-gray-600 flex-shrink-0"
              title="关闭"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default Toaster;
